import { Injectable } from '@angular/core';
import { FiApplicationLanguageType } from '@fi-shared/fi-content-language-shared/fi-application-language-type';
import { cloneDeep, fiGetLocaleCode } from '@fi-shared/utils';
import { INameIdObj } from '@fi-shared/fi-shared-interfaces';

@Injectable()
export class FiLocaleService {
    private monthNames: string[] = [];
    private monthShortNames: string[] = [];
    private dayNames: string[] = [];
    startingDay = 1;

    constructor() {}

    getMonthName(idx: number, isShort?: boolean) {
        if (isShort) return idx < this.monthShortNames.length ? this.monthShortNames[idx] : undefined;
        return idx < this.monthNames.length ? this.monthNames[idx] : undefined;
    }

    getAllDayNames(isSundayFirst?: boolean): string[] {
        const dayNames: string[] = cloneDeep(this.dayNames);
        if (!isSundayFirst) {
            dayNames.push(dayNames.splice(0, 1)[0]);
        }
        return dayNames;
    }

    getDaysOfWeekWithIds(isSundayFirst?: boolean): INameIdObj[] {
        return this.getAllDayNames(isSundayFirst).map((weekDayName: string, index: number): INameIdObj => {
            return { Id: index + 1, Name: weekDayName };
        });
    }

    getAllMonthNames(isShort?: boolean): string[] {
        return isShort ? this.monthShortNames : this.monthNames;
    }

    getMonthsWithIds(isShort?: boolean): INameIdObj[] {
        return this.getAllMonthNames(isShort).map((monthName: string, index: number): INameIdObj => {
            return { Id: index + 1, Name: monthName };
        });
    }

    getDayName(idx: number) {
        return idx < this.dayNames.length ? this.dayNames[idx] : undefined;
    }

    getDaysCount() {
        return this.dayNames.length;
    }

    getLastDayInMonth(month: number): number {
        const now = new Date();
        const nowYear = now.getFullYear();
        const nowMonth = now.getMonth() + 1;
        const testYear = month >= nowMonth ? nowYear : nowYear + 1;
        const testDate = new Date(testYear, month, 0);
        return testDate.getDate();
    }

    getFirstWeekDayOfMonth(month: number, weekday: number): number {
        const date: Date = new Date(new Date().getFullYear(), month, 1);

        while (date.getDay() !== weekday) {
            date.setDate(date.getDate() + 1);
        }

        return date.getDate();
    }

    getLastWeekdayOfMonth(month: number, weekday: number): number {
        const date: Date = new Date(new Date().getFullYear(), month, this.getLastDayInMonth(month));

        while (date.getDay() !== weekday) {
            date.setDate(date.getDate() - 1);
        }

        return date.getDate();
    }

    setLanguage(languageId: FiApplicationLanguageType) {
        const localeCode = fiGetLocaleCode(languageId);

        this.monthNames = [];
        this.monthShortNames = [];
        for (let month = 0; month < 12; month++) {
            const date = new Date(2019, month, 1);
            this.monthNames.push(date.toLocaleString(localeCode, { month: 'long' }));
            this.monthShortNames.push(date.toLocaleString(localeCode, { month: 'short' }));
        }

        this.dayNames = [];
        for (let day = 0; day < 7; day++) {
            const date = new Date(2019, 0, day + 6);
            this.dayNames.push(date.toLocaleString(localeCode, { weekday: 'long' }));
        }
    }
}
